export default __webpack_public_path__ + "static/camera-1baf25dee05f6fcfd79936f8faa035d5.png";